<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部课程</el-breadcrumb-item>
      <el-breadcrumb-item class="ke">课程详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <!--            <div class="course-info-shell">-->
      <!--                <img :src="detail_info.course_img" alt="" class="course-img">-->
      <!--                <div class="course-info">-->
      <!--                    <div class="course-name"></div>-->

      <!--                </div>-->
      <!--            </div>-->
      <!-- 课程购买 -->
      <div v-if="video" class="commodity">
        <div class="imgs">
          <img class="img" :src="detail_info.course_img" alt="" />
        </div>
        <div class="particulars">
          <div class="massage">
            {{ detail_info.course_name }}
          </div>
          <!-- 拼团 -->
          <div class="price">
            <span class="span1"
              >￥{{
                detail_info.level_status
                  ? detail_info.level_price
                  : detail_info.course_price
              }}</span
            >
            <span
              class="original-price"
              v-if="
                detail_info.level_status &&
                  detail_info.level_free == 0 &&
                  detail_info.level_discont != '1.00'
              "
              >原价：￥{{ detail_info.course_price }}</span
            >
            <span
              class="group-btn"
              v-for="(item, index) in detail_info.group_info"
              :key="index + 'c'"
              >{{ item.group_num }}人团</span
            >
            <template v-if="detail_info.coupon_list && detail_info.coupon_list.length > 0">
                <span
                class="coupon-btn"
                v-for="(item, index) in detail_info.coupon_list"
                :key="index + 'd'"
                >优惠券</span
                >
            </template>
            <span class="discount-btn" v-if="detail_info.is_discount">{{
              detail_info.is_discount ? "限时折扣" : ""
            }}</span>
            <div class="share-shell-box">
              <img class="img0" src="@/assets/share.png" alt="" />
              <span class="el-dropdown-link">
                <span class="share">分享</span>
              </span>
              <div class="share-tips">
                <div class="angle"></div>
                <vshare :vshareConfig="vshareConfig"></vshare>
              </div>
            </div>
          </div>
          <div class="coupon-list">
            <div
              class="coupon-box"
              v-for="(item, index) in detail_info.coupon_list"
              :key="index"
            >
              <span class="coupon-box-btn" v-if="index == 0">领券</span>
              <span class="coupon-val">{{ item.coupon_title }}</span>
              <span
                class="coupon-box-btn2"
                @click.stop="take_coupon(item, index)"
                >领取</span
              >
            </div>
          </div>
          <div class="period">学时：{{ detail_info.cnt_course }}课时</div>
          <el-button
            class="Btn1"
            @click="buy()"
            v-if="!detail_info.buy_status && detail_info.free_status !== 1"
            >立即购买</el-button
          >
          <el-button class="Btn1" @click.stop="go_study()" v-else>{{
            detail_info.free_status == 1 ? "免费学习" : "已购买该课程,去学习"
          }}</el-button>
          <template v-if="!detail_info.buy_status">
            <el-button
                class="Btn2"
                @click="group_buy()"
                v-for="(item, index) in detail_info.group_info"
                :key="index"
                >拼团购买
            </el-button>
          </template>
        </div>
      </div>
      <!-- 免费试听视频 -->
      <div v-else class="free">
        <video
          :src="video_src"
          style="margin-left: 0px;"
          controls="controls"
          controlslist="nodownload"
          disablePictureInPicture="true"
          id="myVideo"
        >
          对不起，您的浏览器暂不支持video视频标签!
        </video>
      </div>
      <div class="roll-shell" v-if="course_group.cnt_group > 0">
        <div class="roll-shell-title">
          {{ course_group.cnt_group }}人正在拼团，可直接参与
        </div>
        <div class="roll-list">
          <div
            class="roll-box"
            v-for="(item, index) in course_group.group_list"
            :key="index + 'bb'"
          >
            <div class="roll-box-left">
              <div class="user-img">
                <img :src="item.head_img" alt="" />
              </div>
              <div class="user-name">{{ item.nick_name }}</div>
            </div>
            <div class="roll-box-right">
              <div class="roll-info">
                <div class="num">
                  还剩 <span>{{ item.last_num }}</span> 人成团
                </div>
                <div class="time">剩余 {{ item.last_time }}</div>
              </div>
              <div class="roll-btn" @click="group_buy(item.task_id)">
                立即拼团
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-content-shell">
      <!-- 课程介绍 -->
      <div class="description">
        <el-tabs v-model="activeName">
          <el-tab-pane label="课程介绍" name="first">
            <div class="course_desc" v-html="detail_info.course_desc"></div>
          </el-tab-pane>
          <el-tab-pane
            label="开始学习"
            name="second"
            v-if="detail_info.course_type == 0"
          >
            <div v-for="(item, index) in detail_info.dir_info" :key="index">
              <div class="one">{{ item.directory_name }}</div>
              <div class="box" v-if="item.child_info.length < 1">
                <img src="@/assets/lesson.png" alt="" />
                <span class="span1"
                  >【录播】{{ item.directory_name }}（{{
                    Math.ceil(item.file_time / 60)
                  }}分钟）</span
                >
                <span
                  class="span2 handler"
                  @click.stop="get_play_info(item.directory_id)"
                  v-if="item.free_time > 0"
                  >免费试听</span
                >
              </div>
              <div class="one" v-if="item.child_info.length < 1"></div>
              <div
                class="box"
                v-for="(item2, index2) in item.child_info"
                :key="index2 + 'a'"
              >
                <img src="@/assets/lesson.png" alt="" />
                <span class="span1"
                  >【录播】{{ item2.directory_name }}（{{
                    Math.ceil(item2.file_time / 60)
                  }}分钟）</span
                >
                <span
                  class="span2 handler"
                  @click.stop="get_play_info(item2.directory_id)"
                  v-if="item2.free_status"
                  >免费试听</span
                >
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div
          class="collect-btn"
          :class="{ 'collect-btn-active': detail_info.collect_status }"
          @click.stop="cut_collect"
        >
          <img
            src="@/assets/star.png"
            alt=""
            class="collect-icon"
            v-show="!detail_info.collect_status"
          />
          <img
            src="@/assets/star_active.png"
            alt=""
            class="collect-icon"
            v-show="detail_info.collect_status"
          />
          <div class="cllect-txt">收藏</div>
        </div>
      </div>
      <!-- 老师介绍 -->
      <div class="miss-shell">
        <div
          class="miss"
          v-for="(item, index) in detail_info.teacher_info"
          :key="index"
        >
          <div class="introduce">老师介绍</div>
          <img class="img" :src="item.lector_img" alt="" />
          <div class="teacher">{{ item.lector_name }}</div>
          <div class="college">
            {{ item.lector_desc }}
          </div>
          <div class="correlation">相关课程</div>
          <div class="img2">
            <router-link
              v-for="(item2, index2) in item.lector_course"
              :key="index2 + 'a'"
              target="_blank"
              :to="'Coursetobuy?course_id=' + item2.course_id"
            >
              <img class="img3" :src="item2.course_img" alt="" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="take-coupon-shell"
      v-if="preferential"
      @click.stop="preferential = false"
    >
      <div class="take-coupon-content" @click.stop="">
        <div class="header-handle">
          <img
            src="@/assets/colse-icon.png"
            alt=""
            class="close-btn"
            @click.stop="preferential = false"
          />
        </div>
        <div class="coupon-info">
          <img src="@/assets/zhengque.png" alt="" />
          <div class="info-shell">
            <div class="title">
              恭喜，您已成功领取
              <span>{{ copon_info.coupon_title }}</span> 优惠券
            </div>
            <div class="time">
              有效期限：{{ copon_info.start_time.replace(/-/g, ".") }}-{{
                copon_info.end_time.replace(/-/g, ".")
              }}
            </div>
          </div>

          <router-link class="look-btn" to="/personal?code=5"
            >查看></router-link
          >
        </div>
        <div class="bottom-handle">
          <div class="submit-btn" @click.stop="preferential = false">确 定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Coursetobuy",
  data() {
    return {
      activeName: "first",
      preferential: false,
      collect: false,
      //   视频播放控制
      video: true,
      detail_info: {
        course_type: 1,
      },
      course_id: 1,
      course_group: {
        cnt_group: 0,
        group_list: [],
      },
      countDown: null,
      video_src: "",
      pay_way: 1, // 	1余额 2微信
      vshareConfig: {
        shareList: ["more", "qzone", "tsina", "tqq", "renren", "weixin"],
        share: [{ bdSize: 24 }],
        slide: false,
        image: false,
        selectShare: false,
      },
      copon_info: {
        end_time: "2020-10-16",
        start_time: "2020-10-15",
        copon_info: {
          add_time: 1602733524,
          coupon_id: 2,
          end_time: 1602819924,
          start_time: 1602733524,
          status: 1,
          user_id: 14,
        },
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.query.course_id) {
      this.course_id = this.$route.query.course_id;
      this.get_detail();
      this.get_course_group();
    }
  },
  methods: {
    get_play_info(directory_id) {
      let _this = this;
      this.API.post("Home/course_out-get_play_info", {
        directory_id: directory_id,
      }).then((res) => {
        if (res.data.play_info.buy_status) {
          _this.$router.push(
            "/Gostudy?course_id=" +
              this.course_id +
              "&directory_id=" +
              directory_id
          );
        } else {
          _this.video_src = res.data.play_info.file_url;
          _this.video = false;
          window.scrollTo(0, 0);
          setTimeout(() => {
            let video = document.getElementById("myVideo");
            video.play();
            //使用事件监听方式捕捉事件
            video.addEventListener(
              "timeupdate",
              function() {
                let timeDisplay;
                timeDisplay = Math.ceil(video.currentTime);
                if (
                  timeDisplay >= res.data.play_info.free_time &&
                  !res.data.play_info.buy_status
                ) {
                  _this.API.SMessage("免费观看时间结束");
                  video.pause();
                  video.setAttribute("src", "");
                  _this.video = true;
                }
              },
              false
            );
          }, 500);
        }
      });
    },
    dif_time(endTime) {
      function formatNumber(number) {
        return String(number).padStart(2, "0");
      }

      endTime = new Date(endTime * 1000);
      let startTime = new Date();
      let time_dif = endTime.getTime() - startTime.getTime(); // 时间差
      if (time_dif <= 0) {
        // clearInterval(this.countDown)
        return "00:00:00";
      } else {
        // console.log(time_dif)
        //计算出小时数
        let lv1 = time_dif % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        let h = Math.floor(lv1 / (3600 * 1000));
        //计算相差分钟数
        let lv2 = lv1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        let m = Math.floor(lv2 / (60 * 1000));
        //计算相差秒数
        let lv3 = lv2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        let s = Math.round(lv3 / 1000);
        let time =
          formatNumber(h) + ":" + formatNumber(m) + ":" + formatNumber(s);
        // console.log( h + '小时,' + m + '分钟,' + s + '秒')
        return time;
      }
    },
    get_detail() {
      this.API.post("Home/course_out-get_course_info", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.detail_info = res.data.course_info;
      });
    },
    // 课程收藏 切换
    cut_collect() {
      if (!this.detail_info.collect_status) {
        this.API.post("user/course_in-collect_course", {
          course_id: this.course_id,
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message);
          }
          this.detail_info.collect_status = !this.detail_info.collect_status;
        });
      } else {
        this.API.post("user/course_in-cancel_course", {
          course_id: this.course_id,
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message);
          }
          this.detail_info.collect_status = !this.detail_info.collect_status;
        });
      }
    },
    buy() {
      this.$router.push("/Purchase?course_id=" + this.course_id);
    },
    go_study() {
      this.$router.push("/Gostudy?course_id=" + this.course_id);
    },
    group_buy(task_id) {
      // 拼团购买
      this.API.post("user/group-add_group", {
        task_id: task_id || 0,
        course_id: this.course_id,
        pay_way: this.pay_way,
        is_h5: 2, //	1 普通浏览器 2 PC 3 微信
      }).then((res) => {
        this.$message({
          showClose: true,
          message: res.message,
          type: "success",
        });
        if (res.errno == 0) {
          this.$router.push(
            "/succeed?task_id=" +
              res.data.task_id +
              "&member_id=" +
              res.data.member_id
          );
        }
      });
    },
    get_course_group() {
      let _this = this;
      this.API.post("Home/group-course_group", {
        course_id: this.course_id,
        page: 1,
        page_size: 1000,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.course_group = res.data;
        this.countDown = setInterval(() => {
          for (let i = 0; i < _this.course_group.group_list.length; i++) {
            _this.course_group.group_list[i].last_time = _this.dif_time(
              _this.course_group.group_list[i].end_time
            );
          }
        }, 1000);
      });
    },
    take_coupon(item, index) {
      this.API.post("user/coupon_in-accept_coupon", {
        coupon_id: item.coupon_id,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.copon_info = res.data;
        this.preferential = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.take-coupon-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.5);

  .take-coupon-content {
    min-width: 634px;
    height: 240px;
    background: #ffffff;
    padding: 30px;

    .header-handle {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .close-btn {
        width: 18px;
        height: 18px;
      }
    }

    .coupon-info {
      display: flex;
      align-items: flex-start;

      img {
        width: 47px;
        height: 47px;
        margin-right: 17px;
      }

      .title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;

        span {
          color: rgba(255, 0, 0, 1);
        }
      }

      .time {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-bottom: 27px;
      }

      .look-btn {
        min-width: 56px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #18949c;
        margin: 5px 20px;
      }
    }

    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 89px;
      height: 44px;
      background: #ffffff;
      border: 1px solid #bfbfbf;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-left: 60px;
    }
  }
}

.course-info-shell {
  width: 1200px;
  height: 390px;
  background: #ffffff;
  padding: 30px;
  height: 19px;

  .course-img {
    width: 530px;
    height: 320px;
    margin-right: 30px;
  }
}

.roll-shell {
  width: 1200px;
  background: #ffffff;

  .roll-shell-title {
    display: flex;
    align-items: center;
    height: 100px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    padding-left: 50px;
    border-bottom: 1px solid #f1f1f1;
  }

  .roll-list {
    height: 300px;
    margin-bottom: 26px;
    overflow-y: scroll;

    .roll-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 148px;
      padding: 0 50px;

      .roll-box-left {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
      }

      .roll-box-right {
        display: flex;
        align-items: center;

        .roll-info {
          .num {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;

            span {
              font-size: 24px;
              color: rgba(232, 24, 37, 1);
            }
          }

          .time {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
          }
        }

        .roll-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          width: 120px;
          height: 56px;
          background: #ffa800;
          border-radius: 5px;
          margin-left: 20px;
        }
      }

      .user-img {
        width: 70px;
        height: 70px;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
  }
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  align-items: center;
  height: 94px !important;
}

/deep/ .el-tabs__item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 94px !important;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  display: flex;
  align-items: center;
  height: 100px;
  line-height: 47px;
}

.commodity {
  display: flex;
  align-items: center;
  width: 1200px;
  min-height: 390px;
  margin-bottom: 20px;
  background-color: #fff;

  .imgs {
    .img {
      width: 530px;
      height: 320px;
      margin: 21px 21px 24px 12px;
    }
  }

  .particulars {
    margin: 21px 21px 24px 0;
    display: inline-block;

    .massage {
      width: 576px;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      line-height: 50px;
    }

    .price {
      width: 596px;
      height: 65px;
      background: #f3f3f3;
      position: relative;

      .span1 {
        width: 76px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f21515;
        line-height: 60px;
        margin-right: 20px;
        margin-left: 10px;
      }

      .span2 {
        width: 92px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-decoration: line-through;
        color: #9a9a9a;
        margin-right: 15px;
      }

      .Btn {
        border: 1px solid #22d06e;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #22d06e;
      }

      .Btn0 {
        border: 1px solid #ffa800;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffa800;
      }

      .img0 {
        width: 19px;
        height: 19px;
        /*margin-left: 300px;*/
      }

      .img {
        width: 19px;
        height: 19px;
        margin-left: 200px;
      }

      .img1 {
        width: 19px;
        height: 19px;
        margin-left: 300px;
      }

      .share-tips {
        display: none;
      }

      .share-shell-box {
        display: flex;
        position: absolute;
        top: 20px;
        right: 10px;
      }

      .share-shell-box:hover {
        .share-tips {
          position: absolute;
          bottom: -60px;
          right: 0px;
          display: block;
          background-color: #fff;
          padding: 10px;
          z-index: 9;
          width: 220px;
          border-radius: 5px;
          border: 1px solid #eee;

          .angle {
            position: absolute;
            top: -8px;
            right: 10%;
            width: 10px;
            height: 20px;
            background-color: #fff;
            z-index: 0;
            border-radius: 2px;
            transform: rotate(45deg);
            -ms-transform: rotate(45deg); /* IE 9 */
            -moz-transform: rotate(45deg); /* Firefox */
            -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
            -o-transform: rotate(45deg); /* Opera */
          }
        }
      }

      .share {
        bottom: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
        margin-left: 9px;
      }

      .el-dropdown-menu {
        width: 150px;

        img {
          width: 28px;
          height: 38px;
          margin: 10px;
        }
      }
    }

    .draw {
      margin-top: 10px;

      span:nth-child(1) {
        display: inline-block;
        width: 50px;
        height: 24px;
        text-align: center;
        color: #dc1e1e;
        background: #ffffff;
        border: 1px solid #f21515;
        border-radius: 3px;
      }

      span:nth-child(2) {
        display: inline-block;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-left: 20px;
      }

      span:nth-child(3) {
        display: inline-block;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dc1e1e;
        margin-left: 20px;
      }
    }

    .Btn9 {
      border: 1px solid #dc1e1e;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dc1e1e;
    }

    .period {
      width: 125px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 65px;
    }

    .Btn1 {
      width: 180px;
      height: 60px;
      background: #18949c;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }

    .Btn2 {
      width: 180px;
      height: 60px;
      background: #ffa800;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.free {
  margin-bottom: 20px;
}

.course-content-shell {
  display: flex;
  margin-bottom: 50px;
}

.description {
  position: relative;
  /*float: left;*/
  width: 829px;
  background-color: #fff;
  margin-right: 20px;

  .course_desc {
    padding: 20px;
  }

  /deep/ .el-tabs__item {
    float: left;
    width: 180px;
    text-align: center;
    line-height: 65px;
    height: 65px;
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 500;
  }

  .collect-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 100px;
    top: 25px;
    width: 140px;
    height: 48px;
    border: 1px solid #cccc;
    border-radius: 24px;
    color: #cccccc;

    .collect-icon {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }

  .collect-btn-active {
    color: #fcab2b;
    border-color: #fcab2b;
  }

  .study {
    position: relative;
    left: 50%;
    top: 30px;
    transform: translate(-50%);
    width: 804px;
    height: 639px;
    background-color: pink;
  }

  .production {
    position: relative;
    left: 50%;
    top: 50px;
    transform: translate(-50%);
    width: 735px;
    height: 810px;
    background-color: peru;
  }

  .one {
    min-width: 135px;
    height: 25px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-left: 26px;
    margin-bottom: 26px;
  }

  .box {
    width: 790px;
    height: 70px;
    background: #f4f4f4;
    border-radius: 5px;
    line-height: 70px;
    margin-left: 20px;

    img {
      position: relative;
      top: 5px;
      width: 29px;
      height: 28px;
      margin-left: 24px;
    }

    .span1 {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      margin-left: 15px;
    }

    .span2 {
      float: right;
      margin-right: 38px;
      width: 74px;
      height: 17px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2baab5;
    }
  }
}

.miss-shell {
  background-color: #fff;
  padding-bottom: 40px;
}

.miss {
  /*float: right;*/
  width: 346px;
  min-height: 400px;

  .introduce {
    text-align: center;
    height: 94px;
    line-height: 94px;
    border-bottom: 2px solid #ccc;
    font-size: 24px;
  }

  .img {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-top: 36px;
  }

  .teacher {
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin-top: 23px;
  }

  .college {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 287px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    line-height: 28px;
    margin-top: 23px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .course {
    display: flex;
    height: 130px;
    border-bottom: 1px solid #ccc;

    span {
      flex: 1;
      text-align: center;

      div:nth-child(1) {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin-bottom: 15px;
        margin-top: 50px;
      }
    }
  }

  .correlation {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
  }

  .img2 {
    width: 300px;
    position: relative;
    left: 50%;
    transform: translate(-50%);

    .img3 {
      width: 140px;
      height: 80px;
      margin-right: 10px;
      margin-top: 10px;
    }
  }
}

.preferentialImg {
  float: left;
}

.preferentialBox {
  font-size: 18px;
  margin-left: 75px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;

  span:nth-child(2) {
    color: #dc1e1e;
    font-size: 20px;
    margin: 0 5px;
  }

  span:nth-child(4) {
    margin-left: 10px;
    color: #18949c;
  }

  .el-icon-arrow-right:before {
    content: "\e6e0";
    color: #18949c;
  }
}

.preferentialDate {
  margin-top: 10px;
  margin-left: 75px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.group {
  max-height: 400px;
  background-color: #fff;
  margin: 20px 0;
  overflow-y: scroll;

  .groupBox {
    margin-left: 52px;
    height: 100px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 100px;
    border-bottom: 1px solid #ccc;
  }

  .groupPersonage {
    height: 148px;
    border-bottom: 1px solid #ccc;

    img {
      margin-left: 52px;
      margin-top: 32px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      float: left;
    }

    .span {
      float: left;
      height: 28px;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 148px;
      margin-left: 20px;
    }

    .groupDate {
      float: right;
      margin-top: 53px;
      margin-right: 30px;

      div {
        text-align: right;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
      }
    }

    .groupBtn {
      float: right;
      background: #ffa800;
      border-radius: 5px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-right: 50px;
      margin-top: 60px;
    }
  }
}

.discount-btn {
  width: 96px;
  height: 30px;
  border: 1px solid #21cf6e;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #21cf6e;
  margin-right: 5px;
  margin-left: 5px;
}

.original-price {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-decoration: line-through;
  color: #999999;
}

.group-btn {
  width: 66px;
  height: 30px;
  border: 1px solid #ffa800;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffa800;
  margin-right: 5px;
  margin-left: 5px;
}

.coupon-btn {
  width: 80px;
  height: 30px;
  border: 1px solid #dc1e1e;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #dc1e1e;
  margin-right: 5px;
  margin-left: 5px;
}

.coupon-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 40px;
  margin-top: 10px;

  .coupon-box-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 24px;
    background: #ffffff;
    border: 1px solid #f21515;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #dc1e1e;
    margin-right: 16px;
  }

  .coupon-box {
    margin-right: 10px;
    margin-bottom: 10px;

    .coupon-box-btn2 {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 24px;
      background: #ffffff;
      border-radius: 3px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dc1e1e;
      cursor: pointer;
      text-decoration: underline;
    }

    .coupon-val {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-left: 5px;
    }
  }
}

/deep/ .el-tabs__item {
  font-size: 24px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  color: #999999 !important;
}

/deep/ .el-tabs__item.is-active {
  color: #2aa9b5 !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #2aa9b5 !important;
}

video {
  width: 100%;
}
</style>
